import type { InferOutput } from "valibot";

export const waitlistNotificationSchema = v.object({
  notification_id: v.number(),
  timestamp: v.number(),
  product: productDocumentSchema,
});
export type WaitlistNotification = InferOutput<typeof waitlistNotificationSchema>;

export const waitlistSchema = v.object({
  notifications: v.array(waitlistNotificationSchema),
});
export type Waitlist = InferOutput<typeof waitlistSchema>;

export const addToWaitlistSchema = v.object({
  product_id: v.number(),
  email: v.pipe(v.string(), v.email()),
});
export type AddToWaitlist = InferOutput<typeof addToWaitlistSchema>;

export const removeFromWaitlistSchema = v.object({
  notification_id: v.number(),
});
export type RemoveFromWaitlist = InferOutput<typeof removeFromWaitlistSchema>;
